import { useTranslation } from '@eti/providers';
import { Notification, variants } from '@eti/components';
import { RichTextContent } from '@etg/wings';

const AdditionalTax = () => {
  const { t } = useTranslation();
  return (
    <Notification
      dataTestId="paymentPage-mayChargeAdditionalTax-notification"
      variant={variants.INFORMATION}
    >
      <RichTextContent>{t('Payment.MayChargeAdditionalTax.Notification')}</RichTextContent>
    </Notification>
  );
};

export default AdditionalTax;
